import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation(); // ดึง path ปัจจุบัน

  useEffect(() => {
    window.scrollTo(0, 0); // scroll top ทุกครั้งที่ path เปลี่ยน
  }, [pathname]);

  return null;
}